import { all } from 'redux-saga/effects';
import loginSaga from './auth/saga'
import userSaga from './user/saga'
import transactionSaga from './transactions/saga'
import complaintSaga from './complaints/saga'
import simplSaga from './simpl/saga'
import serviceSaga from './service/saga'
import incentiveSaga from './incentive/saga'
import clientSaga from './client_credential/saga'
import cphSaga from './customer_payment_history/saga'
import emailsSaga from './communication_channel/saga'
import IndicoreSaga from './indicore/saga'
import categorySaga from './categories/saga';

export default function* rootSaga() {
    yield all([
        loginSaga(),
        userSaga(),
        transactionSaga(),
        complaintSaga(),
        simplSaga(),
        cphSaga(),
        serviceSaga(),
        incentiveSaga(),
        clientSaga(),
        emailsSaga(),
        IndicoreSaga(),
        categorySaga()
        
    ])
}